import ModalBasicLayout from "../Modal/ModalBasicLayout";
import ApiKeys from "../../pages/Settings/components/ApiKeys";
import { useTranslationApp } from "../../lib/i18next";
import {
  API_KEYS_TAB_TITLE,
  MODAL_API_KEYS_ARIA_LABEL,
} from "../../i18n/keysTranslations";

/** Above SweetAlert confirm usage (`.bz-alert-container` z-index 9999). */
const MODAL_ABOVE_SWAL_Z_INDEX = 10050;

const ModalApiKeys = ({ modalOpen = false, onCloseModal = () => {} }) => {
  const { t } = useTranslationApp();

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      title={t(API_KEYS_TAB_TITLE)}
      ariaLabel={t(MODAL_API_KEYS_ARIA_LABEL)}
      maxWidth="md"
      fullWidth
      scroll="paper"
      zIndex={MODAL_ABOVE_SWAL_Z_INDEX}
      enableHistoryManagement={false}
      sxContent={{ px: { xs: 2, sm: 3 }, pb: 3 }}
    >
      <ApiKeys variant="modal" onSaveSuccess={onCloseModal} />
    </ModalBasicLayout>
  );
};

export default ModalApiKeys;
